import {
  apiClient,
  type BulkDeleteShipmentOrdersResultEntity
} from '@/libs/api'

export type BulkDeleteShipmentOrdersRequest = {
  tenantKey: string
  ids: number[]
}

/**
 * VOC_PJ-445 #1864: 選択した配送依頼をまとめて物理削除する。
 * 配車済みが1件でも含まれる場合、BE は何も削除せず 400 を返す。
 */
export const bulkDeleteShipmentOrders = async ({
  tenantKey,
  ids
}: BulkDeleteShipmentOrdersRequest): Promise<BulkDeleteShipmentOrdersResultEntity> => {
  const response = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.bulk_delete.$post({
      body: { ids }
    })
  return response.data
}
